/**
 * 环境配置文件
 * 集中管理不同环境的API地址和前端地址
 * 修改此文件无需重新编译项目
 */

export default {
  // 开发环境配置
  development: {
    // 前端域名
    h5Domain: 'mcexchange-h5.local',
    // API域名（不含/Frontend路径）
    apiDomain: 'http://mcexchange-api.local',
    // 完整API基础路径（包含/Frontend）
    apiBaseUrl: 'http://mcexchange-api.local/Frontend'
  },

  // 测试环境配置
  testing: {
    // 前端域名
    h5Domain: 'mcex.s.wxjtest.top',
    // API域名（不含/Frontend路径）
    apiDomain: 'https://mcex-api.s.wxjtest.top',
    // 完整API基础路径（包含/Frontend）
    apiBaseUrl: 'https://mcex-api.s.wxjtest.top/Frontend'
  },

  // 正式环境配置
  production: {
    // 前端域名（匹配所有其他域名）
    h5Domain: '*',
    // API域名（不含/Frontend路径）
    apiDomain: 'http://mcexchange-api.local',
    // 完整API基础路径（包含/Frontend）
    apiBaseUrl: 'http://mcexchange-api.local/Frontend'
  }
}